function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSettingsRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 22a6 6 0 110-12 6 6 0 010 12zm12-9h-.909a11.403 11.403 0 00-1.126-2.723l.641-.641a2.005 2.005 0 000-2.828l-1.414-1.414a2.003 2.003 0 00-2.828 0l-.641.64A11.483 11.483 0 0019 4.909V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v.909c-.964.261-1.877.639-2.723 1.125l-.641-.64a2.003 2.003 0 00-2.828 0L5.394 6.808a2.005 2.005 0 000 2.828l.641.641A11.403 11.403 0 004.909 13H4c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h.909c.26.964.639 1.877 1.126 2.723l-.641.641a2.005 2.005 0 000 2.828l1.414 1.414c.777.779 2.05.779 2.828 0l.641-.641c.846.487 1.759.865 2.723 1.126V28c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-.909a11.444 11.444 0 002.723-1.126l.641.641a2.003 2.003 0 002.828 0l1.414-1.414a2.005 2.005 0 000-2.828l-.641-.641c.487-.846.866-1.759 1.126-2.723H28c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2z",
    fill: props.color
  }));
}

export default SvgIconSettingsRexFilled;